export default __webpack_public_path__ + "static/media/discord-icon.8dc58902.svg";